@if (hasPermission()) {
  <div [class.td-wb-buy-sell__container--secondary]="type() === 'secondary'"
       [class.td-wb-buy-sell__container--xs]="size() === 'xs'"
       class="td-wb-buy-sell__container">
    @if (isEasytradeNativeActive) {
      <button class="td-wb-buy-sell__button td-wb-buy-sell__button--buy"
              [attr.aria-labelledby]="'td-wb-buy-' + buttonId + ' ' + ariaLabelledBy()"
              [attr.aria-describedby]="ariaDescribedBy()"
              tdWbButton
              tdWbButtonType="primary"
              [tdWbButtonSize]="size()"
              (click)="onClickBuyAndSell('buy')">
        <span [attr.id]="'td-wb-buy-' + buttonId"
              [translate]="isXSButtonSize() ? 'tdWb.buySell.BUY_XS' : 'tdWb.buySell.BUY'"></span>
      </button>
      @if (showSell()) {
        <button class="td-wb-buy-sell__button td-wb-buy-sell__button--sell"
                [attr.aria-labelledby]="'td-wb-aria-sell-' + buttonId + ' ' + ariaLabelledBy()"
                [attr.aria-describedby]="ariaDescribedBy()"
                tdWbButton
                tdWbButtonType="destructive-secondary"
                [tdWbButtonSize]="size()"
                (click)="onClickBuyAndSell('sell')">
          <span [attr.id]="'td-wb-aria-sell-' + buttonId"
                [translate]="isXSButtonSize() ? 'tdWb.buySell.SELL_XS' : 'tdWb.buySell.SELL'"></span>
        </button>
      }
    } @else {
      <button class="td-wb-buy-sell__button td-wb-buy-sell__button--buy"
              [attr.aria-labelledby]="'td-wb-buy-' + buttonId + ' ' + ariaLabelledBy()"
              [attr.aria-describedby]="ariaDescribedBy()"
              tdWbButton
              tdWbButtonType="primary"
              [tdWbButtonSize]="size()"
              [tdWbHref]="link"
              [tdWbHrefParams]="buyParams">
        <span [attr.id]="'td-wb-buy-' + buttonId"
              [translate]="isXSButtonSize() ? 'tdWb.buySell.BUY_XS' : 'tdWb.buySell.BUY'"></span>
      </button>
      @if (showSell()) {
        <button class="td-wb-buy-sell__button td-wb-buy-sell__button--sell"
                [attr.aria-labelledby]="'td-wb-aria-sell-' + buttonId + ' ' + ariaLabelledBy()"
                [attr.aria-describedby]="ariaDescribedBy()"
                tdWbButton
                tdWbButtonType="destructive-secondary"
                [tdWbButtonSize]="size()"
                [tdWbHref]="link"
                [tdWbHrefParams]="sellParams">
          <span [attr.id]="'td-wb-aria-sell-' + buttonId"
                [translate]="isXSButtonSize() ? 'tdWb.buySell.SELL_XS' : 'tdWb.buySell.SELL'"></span>
        </button>
      }
    }
  </div>
}
